import { render, staticRenderFns } from "./MessageInput.vue?vue&type=template&id=29cef829&scoped=true&"
import script from "./MessageInput.vue?vue&type=script&lang=js&"
export * from "./MessageInput.vue?vue&type=script&lang=js&"
import style0 from "./MessageInput.vue?vue&type=style&index=0&id=29cef829&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cef829",
  null
  
)

export default component.exports